var render = function render(){var _vm=this,_c=_vm._self._c;return _c('article',{staticClass:"message",class:_vm.messageClass},[(_vm.closable)?_c('button',{staticClass:"delete",class:_vm.buttonClass,on:{"click":function($event){return _vm.close()}}}):_vm._e(),_c('div',{staticClass:"message-body"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }